<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card class="mx-auto">
      <v-card-title
        class="title py-3"
        primary-title
      >
        Xuất danh sách Case theo kỹ thuật
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <!-- <div class="mb-2">Kỹ thuật:</div>
        <v-combobox 
        solo 
        v-model="selectedSupporter" 
        item-text="Name" 
        item-value="Id" 
        :items="supporters" 
        label="Chọn kỹ thuật"
      > 
      </v-combobox> -->
        <div class="d-flex">
          <div class="mr-3">
            <div class="mb-2">Từ ngày:</div>
            <v-menu
              v-model="menuFromDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="200px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                  solo
                  class="date-box"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="menuFromDate = false"></v-date-picker>
            </v-menu>
          </div>
          <div>
            <div class="mb-2">Đến ngày:</div>
            <v-menu
              v-model="menuToDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="200px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                  solo
                  class="date-box"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="menuToDate = false"></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn
          color="success"
          round
          class="text-capitalize px-4"
          :loading="loadingBtn"
          @click="exportTicketsToExcel"
        >
          Xuất file
        </v-btn>
        <v-btn
          color="grey lighten-2"
          @click="close"
          round
          class="text-capitalize"
          style="min-width:85px"
          :disabled="loadingBtn"
        >
          Hủy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import XLSX from 'xlsx';

export default {
  data: () => ({
    dialog: false,
    fromDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    menuFromDate: false,
    toDate: moment().format('YYYY-MM-DD'),
    menuToDate: false,
    loadingBtn: false,
    selectedSupporter: null,
    optionsSupporter: []
  }),

  computed: {
    ...mapGetters(['supporters'])
  },

  methods: {
    ...mapActions(['ExportTicketsBySupporter']),

    open () {
      this.dialog = true;
    },

    close () {
      this.selectedSupporter = null;
      this.dialog = false;
    },

    async exportTicketsToExcel () {
      this.loadingBtn = true;
      let params = {
        // trackingId: String(this.selectedSupporter.Id),
        fromdate: this.fromDate,
        todate: this.toDate,
      };
      let tickets = await this.ExportTicketsBySupporter(params).catch(() => {
        return [];
      });

      if (tickets.length === 0) {
        window.getApp.showMessage('Không tìm thấy dữ liệu!', 'error');
        this.loadingBtn = false;
        return;
      }

      let sheet = XLSX.utils.json_to_sheet(tickets);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'CrmBitrixCases');
      XLSX.writeFile(wb, `CrmBitrixCases-${this.fromDate}-${this.toDate}.xlsx`);
      this.loadingBtn = false;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/pages/dispatch/components/DialogExportTickets.vue